module.exports = __webpack_public_path__ + "img/leadsFilteredSpam.e70e8365.svg";